import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { CustomElement, upgradeProperty, attachShadowTemplate, coerceBoolean } from '@tyler-components-web/core';
import { CHECKBOX_CONSTANTS } from './checkbox-constants';
import { CheckboxFoundation } from './checkbox-foundation';
import { CheckboxAdapter } from './checkbox-adapter';
var template = require('./checkbox.html');
var styles = require('./checkbox.css');
/**
 * The custom element class behind the `<tcw-checkbox>` element.
 */
var CheckboxComponent = /** @class */ (function (_super) {
    __extends(CheckboxComponent, _super);
    function CheckboxComponent() {
        var _this = _super.call(this) || this;
        attachShadowTemplate(_this, CHECKBOX_CONSTANTS.elementName, template, styles);
        _this._foundation = new CheckboxFoundation(new CheckboxAdapter(_this));
        return _this;
    }
    Object.defineProperty(CheckboxComponent, "observedAttributes", {
        get: function () {
            return [CHECKBOX_CONSTANTS.attributes.DENSE];
        },
        enumerable: true,
        configurable: true
    });
    /** Upgrades observed attributes */
    CheckboxComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'dense');
    };
    CheckboxComponent.prototype.connectedCallback = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._ensureInputElement()];
                    case 1:
                        _a.sent();
                        this._foundation.connect();
                        return [2 /*return*/];
                }
            });
        });
    };
    CheckboxComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case CHECKBOX_CONSTANTS.attributes.DENSE:
                this.dense = this.hasAttribute(CHECKBOX_CONSTANTS.attributes.DENSE) && coerceBoolean(newValue);
                break;
        }
    };
    CheckboxComponent.prototype.disconnectedCallback = function () {
        this._foundation.disconnect();
    };
    Object.defineProperty(CheckboxComponent.prototype, "dense", {
        /** Gets or sets whether or not the checkbox is dense */
        get: function () {
            return this._foundation.dense;
        },
        set: function (value) {
            this._foundation.dense = value;
        },
        enumerable: true,
        configurable: true
    });
    CheckboxComponent.prototype._ensureInputElement = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // Not using core function ensureChild because it was not selecting the input properly
                return [2 /*return*/, new Promise(function (resolve) {
                        var element = _this.querySelector('input');
                        if (element) {
                            resolve(element);
                        }
                        var observer = new MutationObserver(function (changes) {
                            var hasAddedNodes = changes.reduce(function (prev, curr) { return prev + curr.addedNodes.length; }, 0) > 0;
                            if (hasAddedNodes) {
                                var foundElement = _this.querySelector('input');
                                if (foundElement) {
                                    observer.disconnect();
                                    resolve(foundElement);
                                }
                            }
                        });
                        observer.observe(_this, { childList: true, subtree: true });
                    })];
            });
        });
    };
    CheckboxComponent = __decorate([
        CustomElement({
            name: CHECKBOX_CONSTANTS.elementName
        })
    ], CheckboxComponent);
    return CheckboxComponent;
}(HTMLElement));
export { CheckboxComponent };
